export default __webpack_public_path__ + "static/spacing-tokens-dark-2e9588a44f2bc03423a75f87e57ae72fcf4b3fea812ffebe6d02edafcd4c9f1f.png";